import { entry } from './actions/entry';
import { call } from './actions/call';
import { queue } from './actions/queue';
import { menu } from './actions/menu';
import { playback } from './actions/playback';
import { postback } from './actions/postback';
import { time } from './actions/time';
import { list } from './actions/list';

export const worksheet = {
  status: {
    active: 'Active',
    draft: 'Not Active'
  },

  tooltips: {
    drag_and_drop: 'Move the desired schema elements to the workspace.'
  },

  modal: {
    remove: {
      content: `Are you sure you want to delete the scheme <b>{name}<b>?`
    },

    remove_action: {
      content: `Are you sure you want to remove the <b>{name}</b> service in the diagram?`
    },

    remove_relationship: {
      content: `Are you sure you want to unlink?`
    },

    create_relationship: {
      title: `Link creation`,
      content: 'Select a join condition'
    },

    action: {
      main: {
        button: {
          ok: '@:shared.component.button.save',
          cancel: '@:shared.component.button.cancel'
        }
      },

      child: {
        button: {
          ok: '@:shared.component.button.confirm',
          cancel: '@:shared.component.button.back'
        }
      }
    }
  },

  action: {
    type: {
      time: 'Time route',
      queue: 'Queue',
      list: 'Numbers list',
      menu: 'IVR Voice Menu',
      playback: 'Playback',
      postback: 'Postback',
      url: 'URL',
      call: 'Call forwarding',
      entry: 'Entry point',
      start: 'Autoinformer',
      media: 'Audio files'
    },

    field: {
      name: {
        title: 'Title'
      }
    },

    entry,
    call,
    queue,
    menu,
    playback,
    postback,
    time,
    list
  }
};
